"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumEventAction = exports.TealiumComponent = exports.TealiumFormat = exports.TealiumAction = exports.PAGE_NAME_TIMEOUT = exports.TIMEOUT_MODAL_EXIT_LINK = exports.TIMEOUT_MODAL_LOGIN_BUTTON = exports.TIMEOUT_MODAL_EXPIRED_VIEW = exports.TIMEOUT_MODAL_LOGOUT_LINK = exports.TIMEOUT_MODAL_EXTEND_SESSION_BUTTON = exports.TIMEOUT_MODAL_WARNING_VIEW = void 0;
exports.TIMEOUT_MODAL_WARNING_VIEW = 'TIMEOUT_MODAL_WARNING_VIEW';
exports.TIMEOUT_MODAL_EXTEND_SESSION_BUTTON = 'TIMEOUT_MODAL_EXTEND_SESSION_BUTTON';
exports.TIMEOUT_MODAL_LOGOUT_LINK = 'TIMEOUT_MODAL_LOGOUT_LINK';
exports.TIMEOUT_MODAL_EXPIRED_VIEW = 'TIMEOUT_MODAL_EXPIRED_VIEW';
exports.TIMEOUT_MODAL_LOGIN_BUTTON = 'TIMEOUT_MODAL_LOGIN_BUTTON';
exports.TIMEOUT_MODAL_EXIT_LINK = 'TIMEOUT_MODAL_EXIT_LINK';
exports.PAGE_NAME_TIMEOUT = 'generic';
var TealiumAction;
(function (TealiumAction) {
    TealiumAction["CONTINUE"] = "continue";
    TealiumAction["OPEN"] = "open";
    TealiumAction["EXIT"] = "exit";
    TealiumAction["LOGIN"] = "login";
    TealiumAction["LOGOUT"] = "logOut";
})(TealiumAction || (exports.TealiumAction = TealiumAction = {}));
var TealiumFormat;
(function (TealiumFormat) {
    TealiumFormat["MODAL"] = "modal";
    TealiumFormat["BUTTON"] = "button";
    TealiumFormat["LINK"] = "link";
})(TealiumFormat || (exports.TealiumFormat = TealiumFormat = {}));
var TealiumComponent;
(function (TealiumComponent) {
    TealiumComponent["TIMEOUT_WARNING"] = "modal/timeOutModal";
    TealiumComponent["TIMEOUT_EXPIRED"] = "modal/sessionExpired";
})(TealiumComponent || (exports.TealiumComponent = TealiumComponent = {}));
var TealiumEventAction;
(function (TealiumEventAction) {
    TealiumEventAction["TIMEOUT_WARNING"] = "timeOutModal";
    TealiumEventAction["TIMEOUT_EXPIRED"] = "sessionExpired";
})(TealiumEventAction || (exports.TealiumEventAction = TealiumEventAction = {}));
//# sourceMappingURL=actions.js.map